import { useNavigate, useLocation } from 'react-router-dom';

export default function BackButton() {
  const navigate = useNavigate();
  const location = useLocation();

  // Ne pas afficher le bouton sur la page d'accueil
  if (location.pathname === '/') {
    return null;
  }

  const handleBack = () => {
    // S'il y a au moins une entrée dans l'historique avant la page actuelle, on y retourne
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      // Pas d'historique : on renvoie à l'accueil
      navigate('/', { replace: true });
    }
  };

  return (
    <button
      onClick={handleBack}
      className="inline-flex items-center gap-2 px-4 py-2 bg-white border-2 border-clinic-blue text-clinic-blue rounded-full hover:bg-clinic-blue hover:text-white transition-all duration-300 shadow-md hover:shadow-lg font-medium whitespace-nowrap cursor-pointer"
    >
      <i className="ri-arrow-left-line text-lg"></i>
      <span>Retour</span>
    </button>
  );
}